import { render } from "./MealGame.vue?vue&type=template&id=0aed5614&scoped=true"
import script from "./MealGame.vue?vue&type=script&lang=js"
export * from "./MealGame.vue?vue&type=script&lang=js"

import "./MealGame.vue?vue&type=style&index=0&id=0aed5614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aed5614"]])

export default __exports__